export default function Logo({ className = "", title = "Logo" }) {
  return (
    <svg
      role="img"
      aria-label={title}
      viewBox="0 0 102 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* 핵심: currentColor 사용해서 부모 텍스트 색을 따라가게 */}
      <path
        fill="currentColor"
        d="M101.1,15.8c0-4.6-3.7-8.3-8.3-8.3s-8.3,3.7-8.3,8.3,3.7,8.3,8.3,8.3,6.4-2.1,7.7-5.1h-5.3c-.7.5-1.5.8-2.4.8-1.7,0-3.1-1-3.7-2.5h11.9c0-.5,0-1,0-1.5ZM89.1,14.1c.6-1.4,2-2.4,3.7-2.4s3.1,1,3.7,2.4h-7.4ZM41.9,17.9l-1.9,2.2v3.7h-4.8V.9h4.8v13.4l5.6-6.5h5.4l-6.1,6.8,6.4,9.1h-5.5s-3.9-5.8-3.9-5.8ZM58.1,23.8h-4.8V7.8h4.8v16ZM12.9,7.8v.9c-1.3-.8-2.8-1.3-4.5-1.3C3.7,7.4,0,11.1,0,15.7s3.7,8.3,8.3,8.3,3.2-.5,4.5-1.3v.9h4.8V7.8h-4.7ZM8.8,19.8c-2.2,0-4-1.8-4-4s1.8-4,4-4,4,1.8,4,4-1.8,4-4,4ZM32.7,7.7v5c-.7-.6-1.6-.9-2.5-.9-2.2,0-4,1.8-4,4v8h-4.8V7.8h4.8v.9c1.3-.8,2.8-1.3,4.5-1.3s1.4,0,2,.3ZM55.6,0c-1.6,0-2.9,1.3-2.9,3s1.3,3,3,3,3-1.3,3-3-1.4-3-3.1-3h0ZM79,7.8h-1c-2.8,0-5.3,1.4-6.7,3.6-1.5-2.1-3.9-3.6-6.7-3.6h-1c-1.9,0-3.4,1.5-3.4,3.4v3.9c0,1.9,1.5,3.4,3.4,3.4h1c2.9,0,5.3,2.4,5.3,5.3h2.9c0-2.9,2.4-5.3,5.3-5.3h1c1.9,0,3.4-1.5,3.4-3.4v-3.9c0-1.9-1.5-3.4-3.4-3.4ZM69.8,17.5c-1.4-1.2-3.3-2-5.3-2h-1c-.3,0-.5-.2-.5-.5v-3.9c0-.3.2-.5.5-.5h1c2.9,0,5.3,2.4,5.3,5.3v1.5ZM79.5,15c0,.3-.2.5-.5.5h-1c-2,0-3.9.7-5.3,2v-1.5c0-2.9,2.4-5.3,5.3-5.3h1c.3,0,.5.2.5.5v3.9Z"
      />
    </svg>
  );
}
